import React, { FormEvent } from "react";
import styles from "./AdLessonLibrary.module.scss";
import Button from "../button/Button";

function AdLessonLibrary() {
  const handleOpenMore = () => {
    window.open(
      "https://learn.openparachuteschools.com/standalone/book-study-overview-na",
      "_blank"
    );
  };

  return (
    <div className={styles.bodyContainer}>
      <div className={styles.textBody}>
        <div className={styles.highlight}>Featured Highlights</div>
        <h1 className={styles.secondaryTitle}>Lesson Library</h1>
        <h1 className={styles.title}>Search</h1>
        <div className={styles.description}>
          <div>
            <ol>
              <li>Topic Keyword</li>
              <li>Competency</li>
              <p>Relationship Skills,</p>
              <p>Responsible Decision-</p>
              <p>Making,  Self-Awareness,</p>
              <p>Self-Management,</p>
              <p>Social Awareness</p>
            </ol>
          </div>
          <div>
            <ol>
              <li>Tier</li>
              <p>1 or 2/3</p>
              <li>Lesson Type</li>
              <p>Student Voice, Positive</p>
              <p>Pathways, Brain Breaks,</p>
              <p>Skill Builders</p>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdLessonLibrary;
